module.exports = __webpack_public_path__ + "static/img/智能识别系统定制.692b0b0d.png";